export const isNullOrUndefined = (value: unknown) => value === null || value === undefined

export const valueIsDefined = <T>(val: T | undefined | null): val is T => {
  return val !== undefined && val !== null
}
